import PropTypes from 'prop-types'
import { memo, useCallback, useMemo, useRef } from 'react'
import { useRootContext } from 'app/services/RootProvider/RootProvider'
import Button from 'components/core/Button/Button'
import classNames from 'lib/util/classNames'
import styles from './ButtonBurger.module.scss'
import useBurgerAnimation from './hooks/useBurgerAnimation'

/**
 * The `ButtonBurger`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function ButtonBurger (props) {
  const { className } = props
  const { isBurgerMenuOpen, setIsBurgerMenuOpen } = useRootContext()

  const ref = useRef()
  const isActive = useBurgerAnimation(ref, isBurgerMenuOpen)
  const classNameOutput = useMemo(
    () => classNames([className, isActive && styles.active]),
    [className, isActive]
  )
  /**
   * Handle click of burger button that opens the burger menu
   */
  const handleClick = useCallback(() => {
    setIsBurgerMenuOpen(!isBurgerMenuOpen)
  }, [isBurgerMenuOpen, setIsBurgerMenuOpen])

  return (
    <Button
      className={classNameOutput}
      type="symbol"
      color="g"
      size="large"
      iconComponent={
        <svg ref={ref} viewBox="0 0 33 33" className={styles.buttonIcon}>
          <path d="M0,5 L33,5" />
          <path d="M0,16.5 L33,16.5" />
          <path d="M0,28 L33,28" />
        </svg>
      }
      onClick={handleClick}
      aria-expanded={isActive}
      aria-haspopup="true"
      title={!isBurgerMenuOpen ? 'Open Menu' : 'Close Menu'}
      useTooltip={true}
      useBorder={false}
    />
  )
}

/** @type {object} */
ButtonBurger.propTypes = {
  className: PropTypes.string
}

/** @type {object} */
ButtonBurger.defaultProps = {
  className: ''
}

// Memoize
export default memo(ButtonBurger)
